<template>
  <Dialog
    :visible="visibility"
    modal
    header="Upload File"
    
    :closable="false"
  >
    <CustomFileUpload 
      v-if="isFileUpload"
      :subject-id="subjectId"
      :style="{ width: '25rem' }"
      @show-toast="onShowToast"
    />
    <CustomURLUpload 
      v-if="!isFileUpload"
      :subject-id="subjectId"
      :style="{ width: '27rem' }"
      @upload-complete="closeDialog"
      @show-toast="onShowToast"
    />
    <div>
      <Button
        type="button" 
        class="p-close-button"
        label="Close" 
        @click="closeDialog"
      />
    </div>
  </Dialog>
</template>
<script>
import Dialog from "primevue/dialog";
import Button from "primevue/button";

import CustomFileUpload from "@/components/knowledgebase/CustomFileUpload.vue";
import CustomURLUpload from "@/components/knowledgebase/CustomURLUpload.vue";

export default {
    components: {
        Dialog,
        Button,
        CustomFileUpload,
        CustomURLUpload
    },
    props: {
      isFileUpload: {
        type: Boolean,
        default: true,
      },
      subjectId: {
        type: String,
        default: null
      },
      visible: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['updateVisibility', 'updateResources', 'show-toast'],
    computed: {
        visibility: {
          get() { return this.visible },
          set(value) { this.$emit('updateVisibility', value) }
        }
    },
    methods: {
        closeDialog() {
            this.visibility = false
        },
        onShowToast(toastData) {
            this.$emit('show-toast', toastData);
        }
    }
};
</script>

<style scoped>
.p-close-button {
  float: right;
  display: inline;
  margin-top: 20px;
}
</style>
